import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import { AnalyticsListener, useAnalyticsEvents } from '@atlaskit/analytics-next';
var ATLASKIT_CHANNEL = 'atlaskit';

/**
 * Lets your treat analytics-next events as a Event API events.
 * Also see {@link createAtlaskitToEventChannelRepackager} if you just want to repackage "atlaskit" channel events.
 */
export var createAnalyticsNextToEventChannelRepackager = function createAnalyticsNextToEventChannelRepackager(useEventDispatch, channel) {
  var RepackageAnalyticsNextEvent = function RepackageAnalyticsNextEvent(_ref) {
    var children = _ref.children,
      uiProperties = _objectWithoutProperties(_ref, _excluded);
    var dispatchAnalytics = useEventDispatch();
    var repackageAtlaskitEvent = useCallback(function (event) {
      dispatchAnalytics(_objectSpread(_objectSpread(_objectSpread({}, uiProperties), event.payload), {}, {
        attributes: _objectSpread(_objectSpread({}, uiProperties.attributes), event.payload.attributes)
      }));
    }, [dispatchAnalytics, uiProperties]);
    return /*#__PURE__*/React.createElement(AnalyticsListener, {
      channel: channel,
      onEvent: repackageAtlaskitEvent
    }, children);
  };
  return RepackageAnalyticsNextEvent;
};

/**
 * Lets your treat atlaskit events as a event channel created from {@link createBaseAnalyticsChannel}.
 * The atlaskit channel gets its own special helper method because it's such a common usecase.
 */
export var createAtlaskitToEventChannelRepackager = function createAtlaskitToEventChannelRepackager(useEventDispatch) {
  var RepackageAtlaskitEvent = createAnalyticsNextToEventChannelRepackager(useEventDispatch, 'atlaskit');
  return RepackageAtlaskitEvent;
};
/**
 * Returns an object that listens to events and fires them as an Atlaskit event on a
 * specified channel
 */
export var createEventChannelToAnalyticsNextRepackager = function createEventChannelToAnalyticsNextRepackager(Listener) {
  var channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ATLASKIT_CHANNEL;
  return function (_ref2) {
    var children = _ref2.children;
    var _useAnalyticsEvents = useAnalyticsEvents(),
      createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var fireAsAtlaskitEvent = useCallback(function (payload) {
      createAnalyticsEvent(payload).fire(channel);
    }, [createAnalyticsEvent]);
    return /*#__PURE__*/React.createElement(Listener, {
      onEvent: fireAsAtlaskitEvent
    }, children);
  };
};